/**
 * Provides unique IDs for objects
 */
export class ObjectUniqueIdProvider {
    static _IdMap = new WeakMap();
    static _NextId = 0;
    constructor() { }
    /**
     * Get the unique ID of the object
     * @param obj Object
     * @returns Unique ID
     */
    static GetId(obj) {
        let id = this._IdMap.get(obj);
        if (id === undefined) {
            id = this._NextId;
            this._NextId += 1;
            this._IdMap.set(obj, id);
        }
        return id;
    }
}
